ACC.manageusers = {
  structure: '',
  intersectionObserverClass: '.ph-intersection-observer',
  infiniteScrollInitiatedClass: '.ph-infinitescrollinitiated',
  dataInitiatedAttribute: 'data-initiated',
  userRowRoleParagraph: '<p class="ph-mycompany__usersrow-role ph-m-0">',

  setObserverUser: function() {
    var container = document.querySelector(ACC.manageusers.intersectionObserverClass);

    function intersection() {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var isIntersecting = entry.isIntersecting;

          if (isIntersecting) {
            if (!$(ACC.searchmanageusers.freeTextInputClass).val()) {
              ACC.manageusers.loadContentSmartly(container, observer);
            }

            observer.observe(container);
          }

          return true;
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0
        });
      });

      observer.observe(container);
    }

    if ('IntersectionObserver' in window) {
      intersection();
    } else {
      $.getScript(ACC.config.commonResourcePath + '/philipsUI/src/js/vendor/intersection-observer.min.js', function() {
        intersection();
      });
    }
  },

  loadContentSmartly: function(container, observer) {
    var pageLength = $('.ph-mycompany__usersrow').length / 5,
        numberOfPages = parseInt($('.ph-ordersshown').attr('data-pagenumber'), 10),
        pageLengths = Math.ceil(pageLength),
        sortName = $('.ph-sortoptions').val(),
        initiated = parseInt($(ACC.manageusers.infiniteScrollInitiatedClass).attr(ACC.manageusers.dataInitiatedAttribute), 10),
        freeSearchLength = $('.ph-manageUsers__freeSearch').length;

    if (freeSearchLength === 0) {
      if ((initiated < pageLengths) && (pageLengths < numberOfPages)) {
        $(ACC.manageusers.infiniteScrollInitiatedClass).attr(ACC.manageusers.dataInitiatedAttribute, pageLengths);

        $.ajax({
          url: ACC.config.contextPath + 'manage-users/manage-users.json?sort=' + sortName + '&page=' + pageLengths,
          async: false,
          success: function(data) {
            $(ACC.manageusers.infiniteScrollInitiatedClass).attr(ACC.manageusers.dataInitiatedAttribute, pageLengths);
            ACC.manageusers.creatingRows(data);
          }
        });
      } else {
        observer.unobserve(container);
        $(ACC.manageusers.intersectionObserverClass).hide();
      }

      observer.unobserve(container);

      if (pageLengths >= numberOfPages) {
        $(ACC.manageusers.intersectionObserverClass).hide();
      } else {
        $(ACC.manageusers.intersectionObserverClass).show();
      }
    }
  },

  creatingRows: function(data) {
    var results = data.results,
        wrapper = document.getElementsByClassName('ph-wrapper')[0],
        active = $('.ph-manageusers_activetext').text(),
        deleted = $('.ph-manageusers_deletedtext').text();

    for (var userDetails in results) {
      if (results !== '') {
        var userRoles = results[userDetails].roles,
            userActive = results[userDetails].active,
            userUid = results[userDetails].uid,
            department = '',
            departmentValue = results[userDetails].department;

        if (departmentValue !== null) {
          department = departmentValue;
        }

        ACC.manageusers.structure = '<div class="ph-mycompany__usersrow ph-mycompany__usersrow--json ph-col-12 ph-float-left">\n' +

        '<div class="ph-d-flex ph-col-12 ph-pb-1">' +

        '<div class="ph-col-md-5 ph-col-7 ph-float-left ph-p-0">\n' +

        '<p class="ph-m-0"><a class="ph-mycompany__usersrow-name" data-userid="' + userUid + '" >' + results[userDetails].name + '</a></p>' +

        '<p class="ph-d-none ph-mycompany_department ph-mycompany_department--mobile ph-m-0">' + department + '</p>';

        ACC.manageusers.addingRoles(userRoles);

        ACC.manageusers.structure = ACC.manageusers.structure + '</div> <div class="ph-mycompany_department ph-mycompany_department--desktop ph-col-4 ph-float-left ph-p-0">' +
                                    department + '</div>';

        if (userActive === true) {
          ACC.manageusers.structure = ACC.manageusers.structure + '<div class="ph-mycompany__usersrow-active ph-col-md-2 ph-col-3 ph-float-left" data-email="' + userUid + '">' +
                                      active + '\n </div>';
        } else {
          ACC.manageusers.structure = ACC.manageusers.structure + '<div class="ph-mycompany__usersrow-active ph-col-md-2 ph-col-3 ph-float-left" data-email="' + userUid + '">' +
                                      deleted + '\n </div>';
        }

        ACC.manageusers.activeUsers(userActive);

        var structureUntilNow = ACC.manageusers.structure;

        ACC.manageusers.structure = ACC.manageusers.tooltipStructure(structureUntilNow, userUid, userActive);

        ACC.manageusers.createTable(results[userDetails].units);

        ACC.manageusers.structure = ACC.manageusers.structure + '</tbody></table>' +
        '</div>\n';

        wrapper.insertAdjacentHTML('beforeend', ACC.manageusers.structure);
      }
    }
  },

  tooltipStructure: function(structureUntilNow, userUid, userActive) {
    var divStrucSec = '</a></div>',
        editDetails = $('.ph-manageusers_editdetailstext').text(),
        deleteUsers = $('.ph-manageusers_deletetext').text(),
        resend = $('.ph-manageusers_resendtext').text(),
        reactivatetext = $('.ph-manageusers_reactivatetext').text(),
        newStructure = '';

    newStructure = structureUntilNow + '<div class="ph-col-md-1 ph-mycompany__usersrow-dots ph-col-2 ph-float-left"><div class="ph-mycompany__usersrow-tooltip hidden">\n' +

    '<div class="ph-pl-1 ph-pt-1"> <a data-userid="' + userUid + '" class="ph-mycompany__usersrow-tooltip--edit">' + editDetails + divStrucSec + '\n';

    newStructure = newStructure + '<div class="ph-pt-1 ph-pl-1 ';

    if ($('.ph-loginRedirectToggle').length !== 0) {
      newStructure = newStructure + ' hidden';
    }

    newStructure = newStructure + '"> <p class="ph-m-0 ph-userid-for-resendmail hidden">' + userUid + '</p>\n' +

    '<a class="ph-mycompany__usersrow-tooltip--resend ph-resendmail">' + resend + divStrucSec + '\n' +

    '<div class="ph-pl-1 ph-pt-1"> <p class="hidden ph-userid-for-disabel ph-m-0">' + userUid + '</p>\n' +

    '<a class="ph-mycompany__usersrow-tooltip--delete ph-disableuser">' + deleteUsers + divStrucSec + '\n' +

    '</div></div></div>';

    newStructure = newStructure + ACC.manageusers.deletedUsers(userActive);

    newStructure = newStructure + '<div class="ph-col-2 ph-mycompany__usersrow-dots ph-col-md-1 ph-float-left"><div class="ph-mycompany__usersrow-tooltip hidden">\n' +

    '<div class="ph-reactive">\n' +

    '<p class="ph-userid-for-disabel hidden ph-m-0">' + userUid + '</p>\n' +

    '<a class="ph-mycompany__usersrow-tooltip--delete ph-reactivate_user">' + reactivatetext + '</a>\n' +

    '</div></div></div></div>\n' +

    '</div>\n' +

    '<table class="ph-col-12 ph-d-flex ph-px-0 ph-mx-1 ph-horizontalline">' +

    '<tbody class="ph-py-1 ph-b2bunit_row">';

    return newStructure;
  },

  createTable: function(unitDetails) {
    for (var units in unitDetails) {
      if (unitDetails.units !== '') {
        ACC.manageusers.structure = ACC.manageusers.structure +
        '<tr><td>' + unitDetails[units].soldToNumber + '</td>' +
        '<td class="ph-pl-1">' + unitDetails[units].soldToName + '</td></tr>';
      }
    }
  },

  deletedUsers: function(userActive) {
    var newStructure = '';

    if (userActive === true) {
      newStructure = '<div class="ph-deleteoption hidden">';
    } else {
      newStructure = '<div class="ph-deleteoption">';
    }

    return newStructure;
  },

  activeUsers: function(userActive) {
    if (userActive === true) {
      ACC.manageusers.structure = ACC.manageusers.structure + '<div class="ph-activeoption">';
    } else {
      ACC.manageusers.structure = ACC.manageusers.structure + '<div class="ph-activeoption hidden">';
    }
  },

  addingRoles: function(userRoles) {
    var admin = $('.ph-administrator').text(),
        approver = $('.ph-approver').text(),
        manager = $('.ph-manager').text();

    if (userRoles.indexOf('b2badmingroup') >= 0) {
      ACC.manageusers.structure = ACC.manageusers.structure + ACC.manageusers.userRowRoleParagraph + admin + '</p>';
    } else if (userRoles.indexOf('b2bmanagergroup') >= 0) {
      ACC.manageusers.structure = ACC.manageusers.structure + ACC.manageusers.userRowRoleParagraph + manager + '</p>';
    } else if (userRoles.indexOf('b2bapprovergroup') >= 0) {
      ACC.manageusers.structure = ACC.manageusers.structure + ACC.manageusers.userRowRoleParagraph + approver + '</p>';
    } else if (userRoles.indexOf('b2bcustomergroup') >= 0) {
      ACC.manageusers.structure = ACC.manageusers.structure + '<p class="ph-mycompany__usersrow-role ph-m-0"></p>';
    }
  }
};

$(document).ready(function() {
  var totalPages = parseInt($('.ph-ordersshown').attr('data-pagenumber'), 10),
      freeSearchInitiated = $('.ph-manageusers__alldata--wrapper').hasClass('ph-manageUsers__freeSearch');

  if ($('.template-pages-AccountPageTemplate .ph-mycompany__usersrow').length > 0 && totalPages > 0 && !freeSearchInitiated) {
    ACC.manageusers.setObserverUser();
  }
});
